import { render, staticRenderFns } from "./Hygiene.vue?vue&type=template&id=1ea48948&scoped=true&"
import script from "./Hygiene.vue?vue&type=script&lang=js&"
export * from "./Hygiene.vue?vue&type=script&lang=js&"
import style0 from "./Hygiene.vue?vue&type=style&index=0&id=1ea48948&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea48948",
  null
  
)

export default component.exports